import React, { createContext, useContext } from 'react';
import { ToastContainer } from 'react-toastify';
const SplashContext = createContext();

export const useSplash = () => {
    const context = useContext(SplashContext);
    if (!context) {
        throw new Error('useSplash must be used within a SplashProvider');
    }
    return context;
};

export const SplashProvider = ({ children, splashData }) => {
    return (
        <SplashContext.Provider value={splashData}>
            {children}
            <ToastContainer />
        </SplashContext.Provider>
    );
}; 